export const state = {
  queue: [],
  myConversations: [],
  selectedConversationId: null,
  messages: {},
  connected: false,
  lastTransfer: null
};

export const mutations = {
  SET_CONNECTED(state, value) {
    state.connected = value;
  },
  SET_QUEUE(state, conversations) {
    state.queue = conversations;
  },
  ADD_TO_QUEUE(state, conversation) {
    if (
      !state.queue.find(c => c.conversationId === conversation.conversationId)
    ) {
      state.queue.push(conversation);
    }
  },
  REMOVE_FROM_QUEUE(state, conversationId) {
    state.queue = state.queue.filter(c => c.conversationId !== conversationId);
  },
  SET_MY_CONVERSATIONS(state, conversations) {
    state.myConversations = conversations;
  },
  ADD_MY_CONVERSATION(state, conversation) {
    if (!state.myConversations.find(c => c.id === conversation.id)) {
      state.myConversations.push(conversation);
    }
  },
  CLOSE_MY_CONVERSATION(state, conversationId) {
    const conv = state.myConversations.find(c => c.id === conversationId);
    if (conv) conv.status = "closed";
  },
  SELECT_CONVERSATION(state, conversationId) {
    state.selectedConversationId = conversationId;
  },
  ADD_MESSAGE(state, { conversationId, message }) {
    if (!state.messages[conversationId]) {
      state.messages = { ...state.messages, [conversationId]: [] };
    }
    state.messages[conversationId].push(message);
  },
  SET_MESSAGES(state, { conversationId, messages }) {
    state.messages = { ...state.messages, [conversationId]: messages };
  },
  SET_LAST_TRANSFER(state, data) {
    state.lastTransfer = data;
  }
};

export const getters = {
  selectedConversation(state) {
    return (
      state.myConversations.find(c => c.id === state.selectedConversationId) ||
      null
    );
  },
  selectedMessages(state) {
    return state.messages[state.selectedConversationId] || [];
  }
};

export const actions = {
  onSocketReconnected({ state }) {
    // Rejoin all active conversation rooms after socket reconnect
    const { watchConversation } = require("@/plugins/chat");
    state.myConversations
      .filter(c => c.status === "active")
      .forEach(c => watchConversation(c.id));
  },

  onNewConversation({ commit }, conversation) {
    commit("ADD_TO_QUEUE", conversation);
  },

  onConversationTaken({ commit }, { conversationId }) {
    commit("REMOVE_FROM_QUEUE", conversationId);
  },

  onJoinSuccess({ commit, dispatch }, conversation) {
    commit("REMOVE_FROM_QUEUE", conversation.id);
    commit("ADD_MY_CONVERSATION", conversation);
    commit("SELECT_CONVERSATION", conversation.id);
    dispatch("loadMessages", conversation.id);
  },

  onMessageReceived(
    { commit },
    { conversationId, senderType, agentId, body, createdAt }
  ) {
    commit("ADD_MESSAGE", {
      conversationId,
      message: { senderType, agentId, body, createdAt }
    });
  },

  onChatClosed({ commit }, { conversationId }) {
    commit("CLOSE_MY_CONVERSATION", conversationId);
  },

  onConversationTransferred({ commit }, data) {
    commit("SET_LAST_TRANSFER", { ...data, _ts: Date.now() });
  },

  async loadMessages({ commit }, conversationId) {
    try {
      const chatApi =
        process.env.VUE_APP_CHAT_API || "https://api-n.nkrdieselparts.com";
      const res = await this._vm.$http.get(
        `${chatApi}/chat/conversations/${conversationId}/messages`
      );
      commit("SET_MESSAGES", { conversationId, messages: res.data });
    } catch (e) {
      console.error("Failed to load messages", e);
    }
  }
};
